import { render, staticRenderFns } from "./AdminNotificationManager.vue?vue&type=template&id=5781b798&"
import script from "./AdminNotificationManager.vue?vue&type=script&lang=ts&"
export * from "./AdminNotificationManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports